export const selectLocationsState = state => state.locations;
export const selectAllLocations = state => state.locations.locations;
export const selectLocationLoading = state => state.locations.loading;
export const selectLocationError = state => state.locations.error;
